// This file is auto-generated by @hey-api/openapi-ts

import type { BackgroundTasksTasksRetrieveResponse, DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse, DirectoutreachPolicyAvailableListResponse, DirectoutreachPolicyAvailableRetrieveResponse, DirectoutreachPolicyCreateResponse, DirectoutreachVotersCreateCreateResponse, DirectoutreachVotersHoldingsRetrieveResponse, DirectoutreachVotersSelectedPolicyCreateResponse, DirectoutreachVotersSelectedPolicyRetrieveResponse, InstitutionalMeetingsearchListResponse, ProxyvotingEntitlementsListResponse, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse, ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponse, ProxyvotingFundManagerSupportedPoliciesCreateResponse, ProxyvotingFundManagerSupportedPoliciesListResponse, ProxyvotingInvestorCompositionsDifferenceListResponse, ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse, ProxyvotingInvestorCompositionsRulesEngineUpdateResponse, ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse, ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponse, ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse, ProxyvotingInvestorSupportedIssuedInstrumentsListResponse, ProxyvotingMeetingBallotsListResponse, ProxyvotingMeetingBallotSourcesListResponse, ProxyvotingPiballotsFilterListResponse, ProxyvotingPimeetingsFilterListResponse, ProxyvotingRulesEngineDefinitionsCreateResponse, ProxyvotingRulesEngineDefinitionsListResponse, ProxyvotingRulesEngineDefinitionsRetrieveResponse, ProxyvotingRulesEngineDefinitionsRulesCreateResponse, ProxyvotingRulesEngineDefinitionsRulesListResponse, ProxyvotingRulesEngineDefinitionsRulesUpdateResponse, ProxyvotingSviProposalOverwriteCreateResponse } from './types.gen';

const taskStatusSchemaResponseTransformer = (data: any) => {
    data.scheduled_at = new Date(data.scheduled_at);
    if (data.started_at) {
        data.started_at = new Date(data.started_at);
    }
    return data;
};

export const backgroundTasksTasksRetrieveResponseTransformer = async (data: any): Promise<BackgroundTasksTasksRetrieveResponse> => {
    data = taskStatusSchemaResponseTransformer(data);
    return data;
};

const exportResultSchemaResponseTransformer = (data: any) => {
    data.exported_at = new Date(data.exported_at);
    return data;
};

export const directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer = async (data: any): Promise<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse> => {
    data = exportResultSchemaResponseTransformer(data);
    return data;
};

const policySchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

export const directoutreachPolicyCreateResponseTransformer = async (data: any): Promise<DirectoutreachPolicyCreateResponse> => {
    data = policySchemaResponseTransformer(data);
    return data;
};

const policyResponseSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

export const directoutreachPolicyAvailableListResponseTransformer = async (data: any): Promise<DirectoutreachPolicyAvailableListResponse> => {
    data = data.map((item: any) => policyResponseSchemaResponseTransformer(item));
    return data;
};

export const directoutreachPolicyAvailableRetrieveResponseTransformer = async (data: any): Promise<DirectoutreachPolicyAvailableRetrieveResponse> => {
    data = policyResponseSchemaResponseTransformer(data);
    return data;
};

const holdingSchemaResponseTransformer = (data: any) => {
    data.valid_time = new Date(data.valid_time);
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

const holdingResponseSchemaResponseTransformer = (data: any) => {
    data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item));
    return data;
};

export const directoutreachVotersHoldingsRetrieveResponseTransformer = async (data: any): Promise<DirectoutreachVotersHoldingsRetrieveResponse> => {
    data = holdingResponseSchemaResponseTransformer(data);
    return data;
};

const selectedPolicySchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    return data;
};

const selectedPolicyResponseSchemaResponseTransformer = (data: any) => {
    if (data.selectedPolicy) {
        data.selectedPolicy = selectedPolicySchemaResponseTransformer(data.selectedPolicy);
    }
    return data;
};

export const directoutreachVotersSelectedPolicyRetrieveResponseTransformer = async (data: any): Promise<DirectoutreachVotersSelectedPolicyRetrieveResponse> => {
    data = selectedPolicyResponseSchemaResponseTransformer(data);
    return data;
};

export const directoutreachVotersSelectedPolicyCreateResponseTransformer = async (data: any): Promise<DirectoutreachVotersSelectedPolicyCreateResponse> => {
    data = selectedPolicyResponseSchemaResponseTransformer(data);
    return data;
};

const voterWithHoldingsResponseSchemaResponseTransformer = (data: any) => {
    data.holdings = data.holdings.map((item: any) => holdingSchemaResponseTransformer(item));
    return data;
};

export const directoutreachVotersCreateCreateResponseTransformer = async (data: any): Promise<DirectoutreachVotersCreateCreateResponse> => {
    data = voterWithHoldingsResponseSchemaResponseTransformer(data);
    return data;
};

const meetingSchemaResponseTransformer = (data: any) => {
    data.meeting_date = new Date(data.meeting_date);
    data.action_deadline = new Date(data.action_deadline);
    return data;
};

const paginatedMeetingListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingSchemaResponseTransformer(item));
    return data;
};

export const institutionalMeetingsearchListResponseTransformer = async (data: any): Promise<InstitutionalMeetingsearchListResponse> => {
    data = paginatedMeetingListSchemaResponseTransformer(data);
    return data;
};

const ballotEntitlementSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    if (data.invalid_time) {
        data.invalid_time = new Date(data.invalid_time);
    }
    return data;
};

const paginatedBallotEntitlementListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => ballotEntitlementSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingEntitlementsListResponseTransformer = async (data: any): Promise<ProxyvotingEntitlementsListResponse> => {
    data = paginatedBallotEntitlementListSchemaResponseTransformer(data);
    return data;
};

const fundManagerPolicySiiSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    if (data.delete_time) {
        data.delete_time = new Date(data.delete_time);
    }
    data.valid_from = new Date(data.valid_from);
    if (data.valid_to) {
        data.valid_to = new Date(data.valid_to);
    }
    return data;
};

const paginatedFundManagerPolicySiiListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => fundManagerPolicySiiSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponseTransformer = async (data: any): Promise<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponse> => {
    data = paginatedFundManagerPolicySiiListSchemaResponseTransformer(data);
    return data;
};

const fundManagerPolicySiiResponseSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => fundManagerPolicySiiSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer = async (data: any): Promise<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse> => {
    data = fundManagerPolicySiiResponseSchemaResponseTransformer(data);
    return data;
};

const fundManagerSupportedVotingPolicyHistoricalSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    if (data.history_date) {
        data.history_date = new Date(data.history_date);
    }
    return data;
};

const paginatedFundManagerSupportedVotingPolicyHistoricalListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => fundManagerSupportedVotingPolicyHistoricalSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingFundManagerSupportedPoliciesListResponseTransformer = async (data: any): Promise<ProxyvotingFundManagerSupportedPoliciesListResponse> => {
    data = paginatedFundManagerSupportedVotingPolicyHistoricalListSchemaResponseTransformer(data);
    return data;
};

const fundManagerSupportedVotingPolicySchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

const fundManagerSupportedVotingPolicyBatchUpsertResponseSchemaResponseTransformer = (data: any) => {
    data.policies = data.policies.map((item: any) => fundManagerSupportedVotingPolicySchemaResponseTransformer(item));
    return data;
};

export const proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer = async (data: any): Promise<ProxyvotingFundManagerSupportedPoliciesCreateResponse> => {
    data = fundManagerSupportedVotingPolicyBatchUpsertResponseSchemaResponseTransformer(data);
    return data;
};

const componentDiffSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    return data;
};

const compositionDifferenceResponseSchemaResponseTransformer = (data: any) => {
    data.components = data.components.map((item: any) => componentDiffSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingInvestorCompositionsDifferenceListResponseTransformer = async (data: any): Promise<ProxyvotingInvestorCompositionsDifferenceListResponse> => {
    data = data.map((item: any) => compositionDifferenceResponseSchemaResponseTransformer(item));
    return data;
};

const investorRulesEngineSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer = async (data: any): Promise<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse> => {
    data = investorRulesEngineSchemaResponseTransformer(data);
    return data;
};

export const proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer = async (data: any): Promise<ProxyvotingInvestorCompositionsRulesEngineUpdateResponse> => {
    data = investorRulesEngineSchemaResponseTransformer(data);
    return data;
};

const investorPolicySiiSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    if (data.delete_time) {
        data.delete_time = new Date(data.delete_time);
    }
    data.valid_from = new Date(data.valid_from);
    if (data.valid_to) {
        data.valid_to = new Date(data.valid_to);
    }
    return data;
};

const paginatedInvestorPolicySiiListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => investorPolicySiiSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingInvestorPolicySupportedIssuedInstrumentsListResponseTransformer = async (data: any): Promise<ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponse> => {
    data = paginatedInvestorPolicySiiListSchemaResponseTransformer(data);
    return data;
};

const investorPolicySiiResponseSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => investorPolicySiiSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer = async (data: any): Promise<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse> => {
    data = investorPolicySiiResponseSchemaResponseTransformer(data);
    return data;
};

const investorSupportedIssuedInstrumentSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    if (data.delete_time) {
        data.delete_time = new Date(data.delete_time);
    }
    data.valid_from = new Date(data.valid_from);
    if (data.valid_to) {
        data.valid_to = new Date(data.valid_to);
    }
    return data;
};

const paginatedInvestorSupportedIssuedInstrumentListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => investorSupportedIssuedInstrumentSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingInvestorSupportedIssuedInstrumentsListResponseTransformer = async (data: any): Promise<ProxyvotingInvestorSupportedIssuedInstrumentsListResponse> => {
    data = paginatedInvestorSupportedIssuedInstrumentListSchemaResponseTransformer(data);
    return data;
};

const investorSiiResponseSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => investorSupportedIssuedInstrumentSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer = async (data: any): Promise<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse> => {
    data = investorSiiResponseSchemaResponseTransformer(data);
    return data;
};

const meetingBallotSourceSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    if (data.invalid_time) {
        data.invalid_time = new Date(data.invalid_time);
    }
    return data;
};

const paginatedMeetingBallotSourceListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingBallotSourceSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingMeetingBallotSourcesListResponseTransformer = async (data: any): Promise<ProxyvotingMeetingBallotSourcesListResponse> => {
    data = paginatedMeetingBallotSourceListSchemaResponseTransformer(data);
    return data;
};

const meetingBallotSchemaResponseTransformer = (data: any) => {
    data.earliest_voting_deadline = new Date(data.earliest_voting_deadline);
    data.latest_voting_deadline = new Date(data.latest_voting_deadline);
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    if (data.complete_time) {
        data.complete_time = new Date(data.complete_time);
    }
    return data;
};

const paginatedMeetingBallotListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => meetingBallotSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingMeetingBallotsListResponseTransformer = async (data: any): Promise<ProxyvotingMeetingBallotsListResponse> => {
    data = paginatedMeetingBallotListSchemaResponseTransformer(data);
    return data;
};

const piBallotSearchSchemaResponseTransformer = (data: any) => {
    data.vote_deadline = new Date(data.vote_deadline);
    return data;
};

const paginatedPiBallotSearchListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => piBallotSearchSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingPiballotsFilterListResponseTransformer = async (data: any): Promise<ProxyvotingPiballotsFilterListResponse> => {
    data = paginatedPiBallotSearchListSchemaResponseTransformer(data);
    return data;
};

const piMeetingSearchSchemaResponseTransformer = (data: any) => {
    data.meeting_time = new Date(data.meeting_time);
    data.submission_deadline = new Date(data.submission_deadline);
    if (data.record_date) {
        data.record_date = new Date(data.record_date);
    }
    if (data.cancel_time) {
        data.cancel_time = new Date(data.cancel_time);
    }
    data.meeting_create_time = new Date(data.meeting_create_time);
    if (data.latest_valid_to_sii) {
        data.latest_valid_to_sii = new Date(data.latest_valid_to_sii);
    }
    if (data.earliest_ballot_submission_deadline) {
        data.earliest_ballot_submission_deadline = new Date(data.earliest_ballot_submission_deadline);
    }
    return data;
};

const paginatedPiMeetingSearchListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => piMeetingSearchSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingPimeetingsFilterListResponseTransformer = async (data: any): Promise<ProxyvotingPimeetingsFilterListResponse> => {
    data = paginatedPiMeetingSearchListSchemaResponseTransformer(data);
    return data;
};

const rulesEngineDefinitionSchemaResponseTransformer = (data: any) => {
    data.valid_from = new Date(data.valid_from);
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

const paginatedRulesEngineDefinitionListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => rulesEngineDefinitionSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingRulesEngineDefinitionsListResponseTransformer = async (data: any): Promise<ProxyvotingRulesEngineDefinitionsListResponse> => {
    data = paginatedRulesEngineDefinitionListSchemaResponseTransformer(data);
    return data;
};

export const proxyvotingRulesEngineDefinitionsCreateResponseTransformer = async (data: any): Promise<ProxyvotingRulesEngineDefinitionsCreateResponse> => {
    data = rulesEngineDefinitionSchemaResponseTransformer(data);
    return data;
};

const rulesEngineRuleSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    data.update_time = new Date(data.update_time);
    return data;
};

const paginatedRulesEngineRuleListSchemaResponseTransformer = (data: any) => {
    data.results = data.results.map((item: any) => rulesEngineRuleSchemaResponseTransformer(item));
    return data;
};

export const proxyvotingRulesEngineDefinitionsRulesListResponseTransformer = async (data: any): Promise<ProxyvotingRulesEngineDefinitionsRulesListResponse> => {
    data = paginatedRulesEngineRuleListSchemaResponseTransformer(data);
    return data;
};

export const proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer = async (data: any): Promise<ProxyvotingRulesEngineDefinitionsRulesCreateResponse> => {
    data = rulesEngineRuleSchemaResponseTransformer(data);
    return data;
};

export const proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer = async (data: any): Promise<ProxyvotingRulesEngineDefinitionsRulesUpdateResponse> => {
    data = rulesEngineRuleSchemaResponseTransformer(data);
    return data;
};

export const proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer = async (data: any): Promise<ProxyvotingRulesEngineDefinitionsRetrieveResponse> => {
    data = rulesEngineDefinitionSchemaResponseTransformer(data);
    return data;
};

const splitVoteInstructionProposalOverwriteSchemaResponseTransformer = (data: any) => {
    data.create_time = new Date(data.create_time);
    if (data.delete_time) {
        data.delete_time = new Date(data.delete_time);
    }
    return data;
};

export const proxyvotingSviProposalOverwriteCreateResponseTransformer = async (data: any): Promise<ProxyvotingSviProposalOverwriteCreateResponse> => {
    data = splitVoteInstructionProposalOverwriteSchemaResponseTransformer(data);
    return data;
};
